import { Autocomplete, TextField } from '@mui/material';

interface Props<T> {
  label: string;
  placeholder: string;
  options: T[];
  value: T[];
  onChange(value: T[]): void;
  getKey(option: T): string | number;
  getLabel(option: T): string;
  /** The options must already be in the order of their groups. */
  groupBy?(option: T): string;
  loading?: boolean;
  helperText?: string;
  error?: boolean;
}

export function ChipPicker<T>({ label, placeholder, options, value, onChange, getKey, getLabel, groupBy, loading, helperText, error }: Props<T>) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      options={options}
      value={value}
      loading={loading}
      loadingText="Henter …"
      noOptionsText="Ingen treff"
      onChange={(_, chosen) => onChange(chosen)}
      getOptionLabel={getLabel}
      getOptionKey={getKey}
      isOptionEqualToValue={(a, b) => getKey(a) === getKey(b)}
      groupBy={groupBy}
      renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} helperText={helperText} error={error} />}
    />
  );
}
